/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type FlashMessagesService from "ember-cli-flash/services/flash-messages";
import type { IntlService } from "ember-intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import VemsDeclaredJournalEvent from "parog-web/models/vems-declared-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class VemsEditionFormComponent extends CrudJournalEventBaseComponent<VemsDeclaredJournalEvent> {
  @service declare flashMessages: FlashMessagesService;
  @service declare session: SemeiaSessionService;
  @service declare intl: IntlService;

  static forcDisplayName = "Exploration fonctionnelle respiratoire";
  static fullComponentId = "vems/edition-form";

  get validations() {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = VemsDeclaredJournalEvent;

  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  get model(): typeof this.journalEventClass {
    // eslint-disable-next-line parog-web/no-use-of-model-in-crud-forc
    const model = super.model;

    if (this.isNewMode) {
      model.occurredAt = new Date();
      model.source = "wise";
    }

    return model;
  }

  get isFromSpirometer() {
    return this.changeset.get("source") != "wise";
  }

  get toastMessage() {
    return this.session.patient
      ? {
          message: "Votre mesure a bien été prise en compte.",
          title: "Spirométrie"
        }
      : super.toastMessage;
  }
}
